import styled, { css, keyframes } from 'styled-components';
import { animated } from 'react-spring';

interface RetractProp {
  isRetract: boolean;
}

const animationButtonSignOut = keyframes`
  0% {
    transform: rotate(-20deg);
  }
  50% {
    transform: rotate(20deg);
  }
  100% {
    transform: rotate(0deg);
  }
`;

export const Container = styled(animated.aside) <RetractProp>`
  grid-area: SB;
  background: ${(props) => props.theme.gradientSidebar};
  width: 100%;
  padding: 0.75rem 2.5rem 0rem 0rem;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  > div svg {
    margin-bottom: 3.75rem;
  }
`;

export const Menu = styled.ul<RetractProp>`
  list-style: none;
  width: 100%;
  flex: 1;

  li + li {
    margin-top: 0.5rem;
  }

  li {
    display: flex;
    height: 2.5rem;
    width: 100%;
    align-items: center;
    justify-content: center;

    ${(props) => props.isRetract && css`
        padding: 0 1rem;
      `}

    a {
      
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      position: relative;
      overflow: hidden;

      > div {
        display: flex;
        align-items: center;
        width: 65%;
        z-index: 1;

        ${(props) => props.isRetract && css`
            width: 100%;
            justify-content: center;
          `}
      }

      &::before {
        content: '';
        position: absolute;
        transition: all 0.2s;
        top: 0;
        right: 0;
        bottom: 0;
        left: 25rem;

        background: ${(props) => props.theme.menuActiveBackground};

        border-top-left-radius: 0.5rem;
        border-bottom-left-radius: 0.5rem;
        border-top-right-radius: 0rem;
        border-bottom-right-radius: 0.5rem;

        ${(props) => props.isRetract && css`
          border-radius: 0.25rem;
          width: 100%;
        `}
      }

      &:hover::before {
        left: 0.875rem;
        ${(props) => props.isRetract && css`
          left: 0;
        `}
      }

      &.active::before {
        left: 0.875rem;
        ${(props) => props.isRetract && css`
          left: 0;
        `}
      }

      p {
        font-weight: 500;
        color: ${(props) => props.theme.itemMenuActive};
        transition: all 0.5s;
        ${(props) => props.isRetract && css`
            visibility: hidden;
            overflow: hidden;
            width: 0;
            height: 0;
          `}
      }

      .icon {
        margin-right: 0.625rem;

        ${(props) => props.isRetract && css`
            margin: 0;
            width: 32px;

        `}
      }
    }
  }
`;

export const Footer = styled.footer<RetractProp>`
  hr {
    border-bottom: 0.1px solid rgba(255, 255, 255, 0.2);
    margin: 1.4rem 0;
  }

  > div,
  > button {
    display: flex;
    align-items: center;
    border: 0;
    background: ${(props) => props.theme.transparent};
    ${(props) =>
    props.isRetract &&
    css`
        flex-direction: column-reverse;

        .icon {
          margin-bottom: 0.5rem;
        }
      `}

    p {
      font-weight: 500;
      color: ${(props) => props.theme.textWhite};
      margin-left: 0.5rem;
    }
  }

  ${(props) =>
    props.isRetract &&
    css`
      > button:hover {
        animation: ${animationButtonSignOut} 1s linear;
      }
    `}
`;

export const Retract = styled.button<RetractProp>`
  position: absolute;
  top: 1.5rem;
  right: -1rem;

  height: 2rem;
  width: 2rem;
  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;

  background: ${(props) => props.theme.green};
  border: 0;
  transition: all 0.5s;
  transform: rotate(90deg);

  ${(props) =>
    props.isRetract &&
    css`
      transform: rotate(270deg);
    `}
`;
